<ng-container *ngIf="Loader.isSpinner; else formContent">
  <app-waiting></app-waiting>
</ng-container>

<ng-template #formContent>
    <form class="f-col blank-form" [formGroup]="EmployeeForm">
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managetraveler.employmentdetails']}} <div class="dot">.</div> <span class="optional">{{content?.['b2b.managetraveler.optional']}}</span></h2>
        <a tabindex="0" role="button" class="link" (click)="Editemployee()" *ngIf="hasEmployeeData && Loader.isEditableClicked  && loginType === '0'"><mat-icon fontSet="material-symbols-outlined"
                class="edit-icon">edit</mat-icon> {{content?.['b2b.managetraveler.edit']}}</a>
    </div>

    <div class="section-content" [class.view-disabled]="Loader.isEditableClicked">
        <div class="inner-contentsection">
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managetraveler.department']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
                        <mat-select formControlName="Department">
                            <mat-option *ngFor="let department of departments" [value]="department.Dept_Id">
                                {{ department.Dept_Name }}
                            </mat-option>

                        </mat-select>
                        <mat-error
                            *ngIf="EmployeeForm.get('Department')?.invalid && EmployeeForm.get('Department')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.selectdepartment']}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managetraveler.employgrade']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
                        <mat-select formControlName="EmployeeGradeCategory">
                            <mat-option *ngFor="let category of employeeGradeCategories" [value]="category.Category_ID">
                                {{ category.Category_Name }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="EmployeeForm.get('EmployeeGradeCategory')?.invalid && EmployeeForm.get('EmployeeGradeCategory')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.selectemployeecategory']}}
                        </mat-error>
                    </mat-form-field>
                </div>


            </div>

            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label> {{content?.['b2b.managetraveler.designation']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
                        <!-- <input matInput formControlName="Designation"> -->
                        <mat-select formControlName="Designation">
                            <mat-option *ngFor="let design of designation" [value]="design.Desig_Id">
                                {{ design.Desig_Name }}
                            </mat-option>

                        </mat-select>
                        <mat-error
                            *ngIf="EmployeeForm.get('Designation')?.invalid && EmployeeForm.get('Designation')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.selectdesignation']}}
                        </mat-error>
                    </mat-form-field>
                </div>

                 <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managetraveler.project']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
                        <!-- <input matInput formControlName="ProjectName"> -->
                        <mat-select formControlName="ProjectName">
                            <mat-option *ngFor="let porj of porject" [value]="porj.Project_Code">
                                {{ porj.Project_Name }}
                            </mat-option>

                        </mat-select>
                        <mat-error
                            *ngIf="EmployeeForm.get('ProjectName')?.invalid && EmployeeForm.get('ProjectName')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.selectprojectname']}}
                        </mat-error>
                    </mat-form-field>
                </div>

            </div>

            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managetraveler.officelocation'] || 'Office Location'}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
                        <mat-select formControlName="OfficeLocation">
                            <mat-option *ngFor="let branch of officeLocations" [value]="branch.Branch_Id">
                                {{ branch.Branch_Name }}
                            </mat-option>

                        </mat-select>
                        <mat-error
                            *ngIf="EmployeeForm.get('OfficeLocation')?.invalid && EmployeeForm.get('OfficeLocation')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.selectofficelocation'] || 'Please select office location'}}
                        </mat-error>
                    </mat-form-field>

                </div>

                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managetraveler.costcenter']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
                        <!-- <input matInput formControlName="CostCenter"> -->
                        <mat-select formControlName="CostCenter">
                            <mat-option *ngFor="let costcent of costcenter" [value]="costcent.CostCenter_Code">
                                {{ costcent.CostCenter_Name }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="EmployeeForm.get('CostCenter')?.invalid && EmployeeForm.get('CostCenter')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.selectcostcenter'] || 'Please select cost center'}}
                        </mat-error>
                    </mat-form-field>
                </div>

            </div>

            <!-- <div class="f-row">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managetraveler.projectopt'].replace('(Optional)','')}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
                        <mat-select formControlName="ProjectName">
                            <mat-option *ngFor="let porj of porject" [value]="porj.Project_Code">
                                {{ porj.Project_Name }}
                            </mat-option>

                        </mat-select>
                        <mat-error
                            *ngIf="EmployeeForm.get('ProjectName')?.invalid && EmployeeForm.get('ProjectName')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.selectprojectname']}}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div> -->
        </div>

        <div class="inner-action" *ngIf="!Loader.isEditableClicked && loginType === '0'">
            <button mat-button class="button--secondary-small" type="button" [class.disabled]="Loader.isEditableClicked" [disabled]="Loader.isEditableClicked" (click)="Cancel()">{{content?.['b2b.managetraveler.cancel']}}</button>
            <button mat-button class="button--primary-small" [class.disabled]="Loader.isEditableClicked || EmployeeForm.invalid || noDataPersonalInfo" [disabled]="Loader.isEditableClicked || EmployeeForm.invalid || noDataPersonalInfo" (click)="onSave()">
                <mat-spinner class="button" *ngIf="Loader.isSpinner"></mat-spinner>
                {{content?.['b2b.managetraveler.save']}}</button>
        </div>
    </div>
</form>
</ng-template>
